/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carousel__PreviousInputs */

const en_carousel__previous = /** @type {(inputs: Carousel__PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous`)
};

/**
* | output |
* | --- |
* | "Previous" |
*
* @param {Carousel__PreviousInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const carousel__previous = /** @type {((inputs?: Carousel__PreviousInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carousel__PreviousInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_carousel__previous(inputs)
});